module.exports = __webpack_public_path__ + "static/media/sms.b931006a.svg";